/* eslint-disable import/prefer-default-export */
import { useMemo, useCallback, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { yieldTypes } from './constants';

export const useSelectYieldTypes = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const selectedYieldType = useMemo(
    () => params?.yieldType || yieldTypes.OFFERS,
    [params?.yieldType]
  );
  const setSelectedYieldType = useCallback(
    (yieldType) =>
      history.replace({ pathname: location.pathname.replace(selectedYieldType, yieldType) }),
    [history, location.pathname, selectedYieldType]
  );
  useEffect(() => {
    if (!Object.values(yieldTypes).includes(selectedYieldType)) {
      setSelectedYieldType(yieldTypes.OFFERS);
    }
  }, [selectedYieldType, setSelectedYieldType]);
  return [selectedYieldType, setSelectedYieldType];
};
